import styled from "styled-components";

export const Wrapper = styled.div`
  animation: 0.3s ease-out 0s 1 slideIn;

  h4 {
    padding: 0 35px;
    font-size: 16px;
  }

  @keyframes slideIn {
    0% {
      transform: translateY(30px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .header-1-of-2,
  .header-2-of-2,
  .header-1-of-3,
  .header-2-of-3,
  .header-3-of-3,
  .header-1-of-4,
  .header-2-of-4,
  .header-3-of-4,
  .header-4-of-4 {
    font-size: 16px;
    text-align: center;
    position: absolute;
    top: 139px;
    padding: 0;
  }

  .header-1-of-2,
  .header-2-of-2 {
    width: 190px;
  }

  .header-1-of-3,
  .header-2-of-3,
  .header-3-of-3 {
    width: 115px;
  }

  .header-1-of-2 {
    right: 225px;
  }

  .header-2-of-2 {
    right: 35px;
  }

  .header-1-of-3 {
    right: 265px;
  }

  .header-2-of-3 {
    right: 150px;
  }

  .header-3-of-3 {
    right: 35px;
  }

  .header-1-of-4,
  .header-2-of-4,
  .header-3-of-4,
  .header-4-of-4 {
    width: 100px;
  }

  .header-1-of-4 {
    right: 335px;
  }

  .header-2-of-4 {
    right: 235px;
  }

  .header-3-of-4 {
    right: 135px;
  }

  .header-4-of-4 {
    right: 35px;
  }

  .padding-below-header {
    padding: 23px;

    @media print {
      padding: 5px;
    }
  }
`;

export const Domain = styled.div`
  position: relative;
  margin-bottom: 30px;

  .question-prefix {
    margin-top: -16px;
    padding-left: 35px;
  }

  @media print {
    margin-top: 30px;

    h4 {
      margin-bottom: 13px;
    }

    p {
      margin-bottom: 12px;
    }
  }
`;

export const Question = styled.div`
  padding: 0 35px 8px;
  position: relative;

  @media print {
    padding-bottom: 0;
    margin-bottom: -2px;
  }

  .background {
    width: 100%;
    background: #f5f5f5;
    box-shadow: 0 0 0 4px #f5f5f5;
  }

  &:nth-child(even) .background2 {
    background: #fff;
    box-shadow: 0 0 0 3px #fff;

    // @media print {
    //   background: #f5f5f5;
    // }
  }

  p {
    width: 425px;
    font-size: 13px;
    margin: 0;
    &.squish {
      width: 375px;
    }
    &.question-landscape {
      width: 525px;
    }
    @media print {
      padding: 3px 0;
    }
  }

  .data {
    position: absolute;
    top: 0;
    right: 90px;
    line-height: 0;

    .column,
    .percent,
    .percent-facility {
      position: absolute;
      top: 0;
      line-height: 20px;
      white-space: nowrap;
    }

    .percent-change {
      position: absolute;
      top: 0;
      right: 185px;
      font-size: 12px;
      line-height: 22px;
      white-space: nowrap;

      &.positive,
      &.negative {
        right: 176px;
      }

      &.positive {
        color: ${props => props.theme.positive};
      }

      &.negative {
        color: ${props => props.theme.negative};
      }
    }

    .percent-1-of-3 {
      right: 217px;
    }

    .percent-2-of-3,
    .percent-facility {
      right: 102px;
    }

    .percent-3-of-3 {
      right: -13px;
    }

    .percentile {
      position: absolute;
      top: 0;
      right: -55px;
      width: 190px;
      line-height: 20px;
      text-align: center;
    }

    .percent-3-of-4 {
      right: 81px;
    }

    .percent-4-of-4 {
      right: -17px;
    }

    &.unit {
      .percentile {
        width: 130px;
      }
    }

    &.sutter.sutter-affiliate-report {
      .percentile {
        width: 115px;
        right: 176px;
      }
      .percent-change {
        right: 63px;
      }
    }

    &.sutter:not(.sutter-affiliate-report) {
      .percentile {
        width: 100px;
        right: 245px;
      }
      .percent {
        right: 182px;
      }
      .percent-change {
        right: 150px;
        font-size: 10px;
      }
    }
  }
`;

export const Footer = styled.div`
  position: absolute;
  left: 35px;
  bottom: 105px;
  h3 {
    color: ${props => props.theme.grey};
    font-weight: bold;
    font-size: 24px;
    margin-top: 0;
  }
  p {
    padding: 0;
    margin: 0;
    font-size: 14px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/PulseQuestions/style.js